import { HttpError } from '@magicdoorinc/errors';
import { FileRepository } from '~/repositories/fileRepository';
import { validateId } from '~/repositories/utils';
import { hoaServiceUrl } from '~/utils/env';
import { urlWithQuery } from '~/utils/url';
import type { AppointHoaBoardMemberDto, HoaBoardMemberDto, HoaBoardMembersDto } from '~/swagger/hoa/Api';

const BASE_URL = `${hoaServiceUrl()}/company-portal/associations/board-members`;

export class BoardMemberRepository extends FileRepository {
  public async list(filter: { active?: boolean }): Promise<HoaBoardMembersDto> {
    const response = await this.fetchWithAuth(urlWithQuery(BASE_URL, filter));
    return this.getJsonResponse(response);
  }

  public async get(id: string): Promise<HoaBoardMemberDto> {
    validateId(id, 'Board member');
    const response = await this.fetchWithAuth(`${BASE_URL}/${id}`);
    return this.getJsonResponse(response);
  }

  public async getByOwner(ownerId: string): Promise<HoaBoardMemberDto | undefined> {
    validateId(ownerId, 'Owner');
    try {
      const response = await this.fetchWithAuth(`${BASE_URL}/by-owner/${ownerId}`, {}, false);
      return this.getJsonResponse(response);
    } catch (error) {
      if (error instanceof HttpError && error.getStatusCode() === 404) return undefined;
      throw error;
    }
  }

  public async appoint(payload: AppointHoaBoardMemberDto): Promise<HoaBoardMemberDto> {
    const response = await this.fetchWithAuth(BASE_URL, { method: 'POST', body: JSON.stringify(payload) });
    return this.getJsonResponse(response);
  }

  public async deactivate(id: string): Promise<HoaBoardMemberDto> {
    validateId(id, 'Board member');
    const response = await this.fetchWithAuth(`${BASE_URL}/${id}/deactivate`, { method: 'POST' });
    return this.getJsonResponse(response);
  }
}

export const boardMemberRepository = new BoardMemberRepository();
